import { FC, useCallback } from 'react';

import styles from 'src/styles/common/templateGallery.module.scss';
import { ScreenType, SetScreenType } from 'src/components/Modals/TemplateGallery/index';
import { TemplateGalleryTitle } from 'src/components/Modals/TemplateGallery/components/Title';
import { TemplateGallerySetupTitleIcon } from 'src/components/Modals/TemplateGallery/icons/SetupTitle';
import { useNsTHelper } from 'src/utils/i18n';
import { TemplateGalleryLinkButton } from 'src/components/Modals/TemplateGallery/components/LinkButton';
import { IconCross } from 'src/components/Icons/Cross';
import { BaseSeparateModal } from 'src/models/modals';

type Props = BaseSeparateModal & {
  currentScreen: ScreenType;
  prevScreen: ScreenType | null;
  setScreen: SetScreenType;
  isByTemplateId: boolean;
  calledFrom: string | null;
};

export const TemplateGalleryHeader: FC<Props> = ({
  currentScreen,
  prevScreen,
  setScreen,
  onClose,
  isByTemplateId,
  calledFrom,
}) => {
  const tHelper = useNsTHelper('modals.templateGallery', currentScreen);

  const setScreenLocal = useCallback(() => {
    if (currentScreen === 'all' || !prevScreen) {
      setScreen('main');
    } else {
      setScreen(prevScreen);
    }
  }, [currentScreen, prevScreen, setScreen]);

  let linkText = tHelper('linkButton');
  if (currentScreen === 'details') {
    if (isByTemplateId) {
      linkText = tHelper('linkButtonFromDetailsById');
    } else if (prevScreen === 'all') {
      linkText = tHelper('linkButtonAll');
    } else {
      linkText = tHelper('linkButton');
    }
  }

  return (
    <div className={styles.header}>
      {/* eslint-disable-next-line no-nested-ternary */}
      {currentScreen === 'main' && calledFrom === 'FromCampaignSetup' ? (
        <TemplateGallerySetupTitleIcon />
      ) : currentScreen === 'main' ? (
        <TemplateGalleryTitle screen="main">{tHelper('title')}</TemplateGalleryTitle>
      ) : (
        <TemplateGalleryLinkButton onClick={setScreenLocal}>{linkText}</TemplateGalleryLinkButton>
      )}

      <IconCross className={styles.headerIcon} onClick={onClose} />
    </div>
  );
};
